<template>
  <div>
    <!-- 並べ替え -->
    <div class="search_option">
      <div class="search_option__sort" data-toggle="buttons">
        <div class="search_option__sort_item">
          <span class="ttl">メーカー名</span>
          <span class="up"   @click="sortFiltered(1)" name="sorter" id="company_sort_asc"  autocomplete="off">▲</span>
          <span class="down" @click="sortFiltered(2)" name="sorter" id="company_sort_desc" autocomplete="off">▼</span>
        </div>
        <div class="search_option__sort_item">
          <span class="ttl">型式</span>
          <span class="up"   @click="sortFiltered(3)" name="sorter" id="type_sort_asc"  autocomplete="off">▲</span>
          <span class="down" @click="sortFiltered(4)" name="sorter" id="type_sort_desc" autocomplete="off">▼</span>
        </div>
        <div class="search_option__sort_link">
					<a @click="sortFiltered(5)" name="sorter" id="category_sort" autocomplete="off">カテゴリ順</a>
				</div>
        <div class="search_option__sort_checkbox">
          <input type="checkbox" id="charter" value="1">
          <label for="charter">チャーター品も含める</label>
        </div>
      </div>
    </div>
    <!-- pagination -->
    <div style="text-align:center">
    <div class="pege_nav">
    <paginate
      :page-count="pageCount"
      :page-range="3"
      :margin-pages="2"
      :click-handler="clickCallback"
      :prev-text="'<'"
      :next-text="'>'"
      :container-class="'pagination'"
      :page-class="'page-item'"  
    >
    </paginate>
    </div>
    </div>

    <ul id="product_child_list" class="list_product">
        <li v-for="product in getItems(filtered)" v-bind:key="product.id">
          <div v-if="!product.isCharter">            
            <router-link :to="{ name: 'single', params: {Id: product.id}}" class="product_status" id="block">    
              <div>
                <img :src="kenki_image_path + product.product.product_code + '-01.jpg'" :alt="product.product.title">
                <span v-if="product.product.netis">NETIS</span>
              </div>
              <dl><dt>{{product.product.title}}</dt>
                <dd class="sp">メーカー：{{product.product.manufacture_name}}</dd>
                <dd class="sp">呼称：{{product.product.product_short_name}}</dd>
                <dd class="sp">型式：{{product.product.product_model_name}}</dd>
                <dd class="sp">商品コード：{{product.product.product_name}}</dd>
              </dl>
            </router-link>
          </div>
          <div v-else>
            <router-link :to="{ name: 'singleCharter', params:{CharterId: product.id}}" class="product_status" id="block">
              <div>
                <img :src="kenki_image_path + product.product.product_code + '-01.jpg'" :alt="product.product.title">
                <span v-if="product.product.netis">NETIS</span>
              </div>
              <dl><dt>{{product.product.title}}</dt>
                <dd class="sp">メーカー：{{product.product.manufacture_name}}</dd>
                <dd class="sp">呼称：{{product.product.product_short_name}}</dd>
                <dd class="sp">型式：{{product.product.product_model_name}}</dd>
                <dd class="sp">商品コード：{{product.product.product_name}}</dd>
              </dl>
            </router-link>            
          </div>
        </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        filtered: [],
        kenki_image_path: '/kenki_images/' + process.env.VUE_APP_COMPANY_ID + '/',
        perPage: 20,
        currentPage: 1,
        pageCount: 0
      }
    },
    methods: {
      setParams: function (searchClass, comId = 1, key = '', id = '', name = ''){
        // key -- search box
        // id --- category_id
        // name - sub_categories ex) tag 
        var param = {};
        if(id){
          param = {
            'limit': 100,
            [searchClass]: {
                'category_id': id,
                'company_id': comId
            }
          }
        }
        else if(name){
          param = {
            'limit': 100, 
            [searchClass]: {
              'sub_categories': {
                'name': name
              },
              'company_id': comId
            }
          }          
        }
        else{
          param = {
            'limit': 100, 
            [searchClass]: {
              'product': {
                'title': key
              },
              'company_id': comId
            }
          }
        }
        return param 
      },
      //for pagination
      clickCallback: function (pageNum) {
        this.currentPage = Number(pageNum)
      },
      getItems: function (filtered) {
        var current = this.currentPage * this.perPage
        var start = current - this.perPage
        return filtered.slice(start, current)
      },
      //for sort
      sortFiltered: function (sortKey = 0) {
        // sortKey 0: no sort, 1: makerName asc, 2: makerName desc, 3: 型式 asc, 4: 型式 desc, 5: カテゴリ順
        function compare_1(a, b){
          var r = 0
          if(a.product.manufacture_name > b.product.manufacture_name){ r = 1 }
          else if(a.product.manufacture_name < b.product.manufacture_name){ r = -1 }
          return r
        }
        function compare_2(a, b){
          var r = 0
          if(a.product.manufacture_name > b.product.manufacture_name){ r = 1 }
          else if(a.product.manufacture_name < b.product.manufacture_name){ r = -1 }
          return (r * -1)
        }
        function compare_3(a, b){
          var r = 0
          if(a.product.product_model_name > b.product.product_model_name){ r = 1 }
          else if(a.product.product_model_name < b.product.product_model_name){ r = -1 }
          return r
        }
        function compare_4(a, b){
          var r = 0
          if(a.product.product_model_name > b.product.product_model_name){ r = 1 }
          else if(a.product.product_model_name < b.product.product_model_name){ r = -1 }
          return (r * -1)
        }
        function compare_5(a, b){
          var r = 0
          if(a.product.title > b.product.title){ r = 1 }
          else if(a.product.title < b.product.title){ r = -1 }
          return r
        }
        if(sortKey === 1){
          this.filtered.sort(compare_1)
        }else if(sortKey === 2){
          this.filtered.sort(compare_2)
        }else if(sortKey === 3){
          this.filtered.sort(compare_3)
        }else if(sortKey === 4){
          this.filtered.sort(compare_4)
        }else if(sortKey === 5){
          this.filtered.sort(compare_5)
        }
      },
      filterProducts: function () {
        var url = process.env.VUE_APP_URL + '/stock_products/search';
        var myToken = process.env.VUE_APP_TOKEN;
        var myComId = process.env.VUE_APP_COMPANY_ID;
        var myKey = this.$route.params.Keyword;
        var myId = this.$route.params.Id;
        var myName = this.$route.params.Name;
        var param = {};
        param = this.setParams('stock_product', myComId, myKey, myId, myName)
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
            'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          for(var i=0;i<data.length;i++){
            data[i]['isCharter'] = false
          }
          this.filtered = data
          this.pageCount = Math.ceil(this.filtered.length / this.perPage)
        })
        .catch(e => console.error(e))
        
        //add chartered_stock_product
        url = process.env.VUE_APP_URL + '/chartered_stock_products/search';
        param = this.setParams('stock_product', myComId, myKey, myId, myName)
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
            'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          for(var i=0;i<data.length;i++){
            data[i]['isCharter'] = true
          }
          this.filtered = this.filtered.concat(data)
          this.pageCount = Math.ceil(this.filtered.length / this.perPage)
        })
        .catch(e => console.error(e))
      }
    },
    mounted () {
      this.filterProducts()
      this.$parent.category_id = this.$route.params.Id
      this.$parent.active_page_title = ''
    },
    watch: {
      '$route': 'filterProducts'
    },
    beforeRouteUpdate(to, from, next){
      next()
      this.$parent.category_id = this.$route.params.Id
      this.$parent.active_page_title = ''
    }
  }
</script>

<style>
  #block {margin-bottom:5px}   

  ul.pagination {
    display: inline-block;
    padding: 0;
    margin: 0;
  }

  ul.pagination li {display: inline;}

  ul.pagination li a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
  }

  ul.pagination li a.active {
    background-color: #4CAF50;
    color: white;
  }
  ul.pagination li a:hover:not(.active) {background-color: #ddd;}
</style>
